import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { emailSliceAction } from '../../store/emailSlice';
import { getRawEmailContent } from '../../utils/awsAPI';
import emptybox from "./../../assets/images/empty-box.png";

const ActiveMailList = () => {
    const dispatch = useDispatch()
    const contactAttributes = useSelector((state:any)=>{return state.emailSlice.contactAttributes})
    const selectedContact = useSelector((state:any)=>{return state.emailSlice.selectedContact})
    const getEmailView = async(mail:any) => {
        dispatch(emailSliceAction.setEmailLoading(true))
        let contactId = mail?.contactId;
        dispatch(emailSliceAction.setSelectedContact(contactId))
        dispatch(emailSliceAction.setSelectedContactDetails(mail))
        let messageId = mail?.contactAttributes?.MessageId2?.value;
        let workmailDomain = mail?.contactAttributes?.WorkmailDomain?.value;
        let result = await getRawEmailContent('inbox',messageId,workmailDomain)
        if(result.success === true) {
            dispatch(emailSliceAction.setEmailDetails(result.data))
        }
        dispatch(emailSliceAction.setEmailLoading(false))
    }

    return (
        <React.Fragment>
            <div className="card wrapup-box collapse show mt-3" id="ChatUser">
                <div className="card-header d-flex justify-content-between align-items-center">
                    <h6 className='m-0'>Active emails</h6>
                </div>
                <div className="card-body height-400">
                    {contactAttributes.length > 0 && 
                        <ul className='list-unstyled m-0'>
                            {contactAttributes.map((mail:any, index:number) => {
                                return (
                                    <li className={`${(selectedContact === mail?.contactId) ? "active_contacts" : "inactive_contacts"}`} key={index}>
                                        <button onClick={()=>{ getEmailView(mail)}} className='chat-user-box'>
                                            <div className='chat-user-icon'>
                                                {mail?.contactAttributes?.Sender?.value.substring(0,1).toUpperCase()}
                                            </div>
                                            <div className='chat-user-name'>
                                                <div className='chuser-name'>{(mail?.contactAttributes?.Sender?.value.length > 20 ? mail?.contactAttributes?.Sender?.value.substring(0,20)+'...' : mail?.contactAttributes?.Sender?.value) }</div>
                                                <div className='chuser-msg'>{(mail?.contactAttributes?.Subject?.value.length > 20 ? mail?.contactAttributes?.Subject?.value.substring(0,20)+'...' : mail?.contactAttributes?.Subject?.value) }</div>
                                            </div>
                                        </button>
                                    </li>
                                )
                            })}
                        </ul>
                    }
                    {contactAttributes.length === 0 &&
                        <div className='empty-data'>
                            <img className='empty-icon' src={emptybox} alt="empty box icon" />
                            <h4>No data available</h4>
                        </div>
                    }
                </div>
            </div>
        </React.Fragment>
    )
}
export default ActiveMailList;